import { useState, useEffect, useRef } from 'react'
import { NoRecords, PageLoader } from '../../lib/loader'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import moment from 'moment';
import { useUserHistory } from './UserDetailapi';
import { Search, Eye, Check, Copy } from 'lucide-react';
import { useDebounce } from '../../hooks/debounce';
import { useParams } from 'react-router-dom';
import { Modal, ModalBody } from 'reactstrap';
import close from '../../assets/images/icons/close-circle.svg'
import { copyToClipboard } from '../../lib/copytoClipboard';
import { useModalContext } from '../../contexts/ModalContext';
import { useToast } from '../../hooks/usetoast';
import { useCheckAdminAccess } from '../WhiteIp/api/whiteipapi';
import { logout } from '../../hooks/logout';
import PermissionDenied from '../common/permissionDenied';
import { WaitingLoader } from '../../hooks/buttonLoad';
import BreadcrumbPagination from '../../utils/BreadcrumbPagination';
import { useBreadcrumbPagination } from '../../hooks/useBreadcrumbPagination';

function DeletedAccountHistory() {

    const [tempPage, setTempPage] = useState(0);
    const [tempRows, setTempRows] = useState(25);
    const [search, setSearch] = useState("");
    const searchText = useDebounce(search);
    const { id } = useParams();
    const [open, setOpen] = useState(false)
    const [reason, setReason] = useState("")
    const { theme } = useModalContext()
    const toast = useToast();
    const [userEmail, setUserEmail] = useState(false);
    const toggle = () => setOpen(!open)
    const { data: getUserHistory, isLoading } = useUserHistory({
        id,
        page: searchText ? 0 : tempPage,
        size: tempRows,
        searchText,
        deleteStatus: "Deleted",
        sortField: "createdAt",
        sortOrder: "desc"
    })

    const totalRecords = getUserHistory?.data?.totalRecords || 0;

    const {
        page,
        rowsPerPage,
        totalPages,
        handleChangePage,
        handleChangeRowsPerPage
    } = useBreadcrumbPagination(totalRecords, tempRows);

    useEffect(() => {
        setTempPage(page);
    }, [page]);

    useEffect(() => {
        setTempRows(rowsPerPage);
    }, [rowsPerPage]);

    const inputRef = useRef(null);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
            const length = inputRef.current.value.length;
            inputRef.current.setSelectionRange(length, length);
        }
    });

    useEffect(() => {
        setTempPage(0);
        if (handleChangePage) {
            handleChangePage(null, 0);
        }
    }, [searchText]);



    const handleReason = (reason) => {
        setReason(reason)
        toggle()
    }

    const copyUserEmailAddress = async data => {
        setUserEmail(data._id)
        await copyToClipboard(data?.email)
        toast.success("Email Address copied")
        setTimeout(() => {
            setUserEmail()
        }, 800)
    }

    const checkAdminMutation = useCheckAdminAccess();
    const [access, setAccess] = useState(true);

    useEffect(() => {
        checkAdminAccess();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const checkAdminAccess = async () => {
        try {
            const obj = { page: 'User Management' };
            const checkAdminRes = await checkAdminMutation.mutateAsync(obj);
            if (!checkAdminRes?.data?.status) {
                setAccess(false);
                logout();
            } else {
                setAccess(true);
            }
        } catch (error) {
            setAccess(false);
        }
    };

    const renderUserHistoryTable = () => (
        getUserHistory?.data?.usersHistory?.length > 0 ? (
            <>
                <div style={{ minHeight: "60vh" }}>
                    <div className='table-responsive'>
                        <Table sx={{ minWidth: 650 }} aria-label="user history table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">S.NO</TableCell>
                                    <TableCell align="center">User Name</TableCell>
                                    <TableCell align="center">Email</TableCell>
                                    <TableCell align="center">Email Verified</TableCell>
                                    <TableCell align="center">Mobile Verified</TableCell>
                                    <TableCell align="center">Account Status</TableCell>
                                    <TableCell align="center">KYC Status</TableCell>
                                    <TableCell align="center">Reason</TableCell>
                                    <TableCell align="center">Date and Time </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {getUserHistory?.data?.usersHistory?.map((row, i) => (
                                    <TableRow key={row._id || i}>
                                        <TableCell align="center">{page * rowsPerPage + (i + 1)}</TableCell>
                                        <TableCell align="center">{row?.userName}</TableCell>
                                        <TableCell align="center">
                                            {row?.email || "-"}
                                            {userEmail === row._id ? (
                                                <Check size={20} style={{ marginLeft: "5px", color: theme ? "white" : 'black' }} />
                                            ) : (
                                                <Copy
                                                    onClick={() => copyUserEmailAddress(row)}
                                                    size={20}
                                                    className='ml-5'
                                                    style={{ cursor: "pointer", marginLeft: "5px", color: theme ? "white" : 'black' }}
                                                />
                                            )}
                                        </TableCell>
                                        <TableCell align="center">{row?.isEmailVerified ? "Yes" : "No"}</TableCell>
                                        <TableCell align="center">{row?.isMobileVerified ? "Yes" : "No"}</TableCell>
                                        <TableCell align="center" className={row?.accountDeletionStatus === "Rejected" ? "text-warning" : "text-danger"}>
                                            {row?.accountDeletionStatus}
                                        </TableCell>

                                        <TableCell align="center">{row?.isKycStatus}</TableCell>
                                        <TableCell align="center" onClick={() => handleReason(row?.deleteReason)}>
                                            <Eye className="mx-3" size={20} type='button'
                                            />
                                        </TableCell>
                                        <TableCell align="center">
                                            {moment(row?.createdAt).format("DD-MM-YYYY | hh:mm A")}
                                        </TableCell>


                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </div>
                </div>
                <BreadcrumbPagination
                    page={page}
                    rowsPerPage={rowsPerPage}
                    totalPages={totalPages}
                    totalRecords={totalRecords}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                />
            </>
        ) : (
            <NoRecords />
        )
    );


    let content;

    if (isLoading) {
        content = <WaitingLoader />;
    } else if (access) {
        content = (
            <section>
                <h4>Deleted Account History</h4>
                <div className="ad_pg_bx bg-white p-3">
                    <div className='d-flex justify-content-between align-items-center mb-2'>
                        <div className='col-md-4'>
                            <div className="input-group">
                                <span className="input-group-icon">
                                    <Search size={20} color='#aaa9a9' />
                                </span>
                                <input
                                    type="text"
                                    ref={inputRef}
                                    onChange={(e) => setSearch(e.target.value)}
                                    value={search}
                                    className="form-control"
                                    placeholder="Search by name , email"
                                />
                            </div>
                        </div>
                    </div>
                    {isLoading ? <PageLoader /> : renderUserHistoryTable()}
                </div>

                <Modal isOpen={open} toggle={toggle} centered>
                    <div className="modal-header">
                        <h4 className="modal-title">Reason</h4>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={toggle}
                            aria-label="Close"
                        >
                            <img src={close} alt="close-circle" />
                        </button>
                    </div>
                    <ModalBody>
                        <input
                            placeholder="Enter IP"
                            className="form-control"
                            value={reason}
                            disabled
                        />
                    </ModalBody>
                </Modal>
            </section>
        );
    } else {
        content = <PermissionDenied />;
    }

    return <>{content}</>;
}

export default DeletedAccountHistory